import { Flex, FormItemsGroup, Text } from '@billy/design-system'
import { useCallback } from 'react'
import { useTranslation } from 'react-i18next'

import { InvoiceLineColumn } from '@features/invoices/types/invoiceLineColumn'

import { useIsInvoiceEditorElementRestricted } from '../../../../../../../../../../../../hooks/useIsInvoiceEditorElementRestricted'
import { useInvoiceLinesColumns } from '../../../../../../hooks/useInvoiceLinesColumns'
import { CommonInvoiceLineFieldProps } from '../../../../types/commonInvoiceLineFieldProps'
import { InvoiceSubtotalExcludingVat } from './elements/InvoiceSubtotalExcludingVat'
import { InvoiceSubtotalIncludingVat } from './elements/InvoiceSubtotalIncludingVat'

type InvoiceSubtotalLineFieldsProps = CommonInvoiceLineFieldProps

export const InvoiceSubtotalLineFields = ({ lineIndex }: InvoiceSubtotalLineFieldsProps) => {
  const { t } = useTranslation()
  const { columns, columnItemsTemplate } = useInvoiceLinesColumns()

  const isSubtotalExcludingVatIndexDisabled = useIsInvoiceEditorElementRestricted('netTotal', 'disabled')
  const isSubtotalIncludingVatIndexDisabled = useIsInvoiceEditorElementRestricted('total', 'disabled')

  const getColumnIndex = useCallback(
    (columnName: InvoiceLineColumn) => {
      const index = columns.indexOf(columnName)
      return index === -1 ? undefined : index
    },
    [columns],
  )

  const subtotalExcludingVatIndex = getColumnIndex('netTotal')
  const subtotalIncludingVatIndex = getColumnIndex('total')

  return (
    <FormItemsGroup itemsInRow={columnItemsTemplate.length} itemsTemplate={columnItemsTemplate}>
      <Flex alignItems="center">
        <Text weight="bold">{t('external_invoices.editor.form.field.line.field.subtotal_content.title')}</Text>
      </Flex>
      {subtotalExcludingVatIndex && (
        <InvoiceSubtotalExcludingVat
          disabled={isSubtotalExcludingVatIndexDisabled}
          lineIndex={lineIndex}
          columnIndex={subtotalExcludingVatIndex}
        />
      )}
      {subtotalIncludingVatIndex && (
        <InvoiceSubtotalIncludingVat
          disabled={isSubtotalIncludingVatIndexDisabled}
          lineIndex={lineIndex}
          columnIndex={subtotalIncludingVatIndex}
        />
      )}
    </FormItemsGroup>
  )
}
